import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  PharmacyClient,
  UsersClient,
  EnumsClient,
  DrugClient,
  WorkflowClient,
  DrugDetailsClient,
  OrderClient,
  PatientClient,
  AuthClient,
  ManufacturerClient,
  ShipmentClient,
  SentrexDriverScheduleClient,
  IssueTypeClient,
  AttachmentClient,
  PatientCoverageIntegrationClient,
  OrderLockClient,
  PatientWorkflowLockClient,
  HolidayClient,
  DashboardClient,
  ManagerAnalyticsClient,
  GamificationClient,
  // Talkdesk is not being released yet — TalkdeskClient was removed by the NSwag regen. Restore
  // this import and its provider below when Talkdesk ships (uncomment the controller + re-run NSwag).
  // TalkdeskClient,
  FeatureFlagClient,
} from 'src/httpClient/luminav-link-api';

@NgModule({
  providers: [
    PharmacyClient,
    UsersClient,
    EnumsClient,
    WorkflowClient,
    DrugDetailsClient,
    DrugClient,
    OrderClient,
    PatientClient,
    AuthClient,
    ManufacturerClient,
    ShipmentClient,
    SentrexDriverScheduleClient,
    IssueTypeClient,
    AttachmentClient,
    PatientCoverageIntegrationClient,
    OrderLockClient,
    PatientWorkflowLockClient,
    HolidayClient,
    DashboardClient,
    ManagerAnalyticsClient,
    GamificationClient,
    // TalkdeskClient,  // Talkdesk not released yet — see the commented import above.
    FeatureFlagClient,
  ],
})

/**
 * Provides the LuminavLinkClientModule for the application.
 *
 * This module is used to provide the LuminavLinkClientModule to the application.
 * It is a module that is used to provide the LuminavLinkClientModule to the application.
 */
export class LuminavLinkClientModule {
  static forRoot(): ModuleWithProviders<LuminavLinkClientModule> {
    return {
      ngModule: LuminavLinkClientModule,
    };
  }
}

/**
 * Provides the API base URL for the LuminavLinkClientModule.
 *
 * This constant is used to inject the API base URL into the LuminavLinkClientModule.
 * It is a constant object that is used to provide the API base URL to the LuminavLinkClientModule.
 *
 * @constant
 * @type {InjectionToken<string>}
 * @default environment.base_url
 */
// export const LUMINAV_LINK_CLIENT_URL_PROVIDER =
// {
//     provide: API_BASE_URL,
//     useValue: environment.base_url
// } as const;
